// extracted by mini-css-extract-plugin
module.exports = {"navbarLinksOpen":"styles_navbarLinksOpen__d7Bjo","navbarLinksClose":"styles_navbarLinksClose__3Dl2Z","navbar":"styles_navbar__2TWC4"};